'use client';
import { BottomSheet } from '@/components/ui';
import { AchievementModal } from './AchievementModal';

/** Shared bottom-sheet that shows a single achievement's detail. The title
 *  lives in the modal body, so the sheet is header-less (floating close only). */
export function AchievementDetailSheet({
  achievementKey,
  onClose,
}: {
  achievementKey: string | null;
  onClose: () => void;
}) {
  return (
    <BottomSheet
      isOpen={!!achievementKey}
      onClose={onClose}
      title=""
      hideHeader
      panelClassName="!bg-[#141414]"
      bodyClassName="!px-0"
    >
      {achievementKey && <AchievementModal achievementKey={achievementKey} />}
    </BottomSheet>
  );
}
